import React from "react";
import { IndexForms } from "@hex-insights/app-modules";
import { ClassNameProps, StyleProps } from "@hex-insights/core";
import { FormState, StandingForm } from "@hex-insights/forms";
import { useHistory, useLocation } from "@hex-insights/router";
import { SearchField } from "../Field";

export type SearchFormProps = {
	formState: FormState<IndexForms.SearchFormValues>;
	fieldClassName?: string;
} & Partial<ClassNameProps & StyleProps>;

/**
 * A search form for index results.
 */
export function SearchForm({ formState, fieldClassName, className, style }: SearchFormProps) {
	const { action } = useHistory();
	const { hash, isMount } = useLocation();
	const [autoFocus] = React.useState(() => {
		const isBackAction = !isMount && action === "POP";
		return !(hash || isBackAction);
	});

	return (
		<StandingForm className={className} style={style}>
			<SearchField
				formState={formState}
				name="search"
				placeholder="Search"
				autoFocus={autoFocus}
				noHeader
				className={fieldClassName}
			/>
		</StandingForm>
	);
}
